export default __webpack_public_path__ + "static/media/kitchen4-afterB-1920w.70828f87.png";